import { render, staticRenderFns } from "./IconSvgNYSSCPA.vue?vue&type=template&id=eb5d159e&scoped=true&"
import script from "./IconSvgNYSSCPA.vue?vue&type=script&lang=js&"
export * from "./IconSvgNYSSCPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5d159e",
  null
  
)

export default component.exports